import { render } from "./AppLogo.vue?vue&type=template&id=ea9a6b8c&scoped=true"
const script = {}

import "./AppLogo.vue?vue&type=style&index=0&id=ea9a6b8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9a6b8c"]])

export default __exports__